<template>
    <div>
        <vue-multiselect
            v-model="value"
            :options="selectOptions"
            :searchable="true"
            :internal-search="internalSearch"
            :label="label"
            :track-by="trackBy"
            placeholder=""
            :select-label="labelSelect"
            :deselect-label="labelDeselect"
            :selected-label="labelSelected"
            :open-direction="openDirection"
            :disabled="disabled"
            :allow-empty="allowEmpty"
            @select="$emit('dispatch',$event)"
            @input="$emit('option-selected', $event)"
            @remove="$emit('remove', $event)"
            @search-change="$emit('search-change', $event)"
            @open="$emit('open', $event)"
        >
            <span slot="noResult">Brak wyników. Spróbuj zmienić wpisywaną frazę.</span>
        </vue-multiselect>
    </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'

export default {
  components: {
    VueMultiselect
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: 'name'
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    checked:{
      type: [String, Number],
      default: null
    },
    disabled:{
      type: Boolean,
      default: false
    },
    allowEmpty:{
      type: Boolean,
      default: true,
    },
    sortBy:{
      type: String,
      default: null,
    },
    openDirection:{
      type: String,
      default: null,
    },
    internalSearch:{
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      value: null,
      selectOptions : this.generateOptions(this.options),
      labelSelect: Translator.trans('multiselect.select'),
      labelDeselect: this.allowEmpty ? Translator.trans('multiselect.remove') : '',
      labelSelected: Translator.trans('multiselect.selected'),
    }
  },
  watch : {
    value: function (value) {
      let emit = value ? value[this.trackBy] : null
      this.$emit('input', emit)
      this.selectOptions.length && this.$emit('change', emit)
    },
    checked: function() {
      this.value = this.prepareValue()
      this.$emit('checked', this.value)
    },
    options: function(options) {
      this.selectOptions = this.generateOptions(options)
      this.value = this.prepareValue()
    },
  },
  mounted() {
    this.value = this.prepareValue()
  },
  methods: {
    generateOptions(options) {
      let generatedOptions = typeof options === 'object' ? Object.values(options) : options
      if (this.sortBy) {
        let sortBy = this.sortBy
        generatedOptions.sort((a, b) => a[sortBy] - b[sortBy])
      }

      return generatedOptions
    },
    prepareValue() {
      let prepareValue = {}
      let checked = parseInt(this.checked)
      checked = Number.isInteger(checked) ? checked : this.checked

      prepareValue[this.trackBy] = checked
      for (let i = 0; i < this.selectOptions.length ; i++) {
        if (this.selectOptions[i][this.trackBy] === checked) {
          prepareValue[this.label] = this.selectOptions[i][this.label]
        }
      }

      this.$emit('input', checked)
      return prepareValue
    }
  },
}
</script>
